import { Tag } from "antd";
import { UserRequestStatus } from "../enums/global.enums";
import { CSSProperties } from "react";

export function requestStatusPipe(value: string) {
    switch (value) {
        case UserRequestStatus.All: return "Tất cả";
        case UserRequestStatus.Pending: return "Chờ xử lý";
        case UserRequestStatus.InProcess: return "Đang xử lý";
        case UserRequestStatus.Completed: return "Đã hoàn thành";
        case UserRequestStatus.Cancelled: return "Đã hủy";
        default: return "Đang xử lý";
    }
}

export function requestStatusTagPipe(value?: string, style?: CSSProperties) {
    switch (value) {
        case UserRequestStatus.All: return <Tag color="default" style={style}>{requestStatusPipe(value || "")}</Tag>;
        case UserRequestStatus.Pending: return <Tag color="warning" style={style}>{requestStatusPipe(value || "")}</Tag>;
        case UserRequestStatus.InProcess: return <Tag color="processing" style={style}>{requestStatusPipe(value || "")}</Tag>;
        case UserRequestStatus.Completed: return <Tag color="success" style={style}>{requestStatusPipe(value || "")}</Tag>;
        case UserRequestStatus.Cancelled: return <Tag color="error" style={style}>{requestStatusPipe(value || "")}</Tag>;
        default: return <Tag color="default" style={style}>{requestStatusPipe(value || "")}</Tag>;
    }
}
